import { useEffect } from "react";

export function useIntersectionObserver(
  ref: React.RefObject<Element>,
  callback: () => void,
  options?: {
    root?: Element | null;
    rootMargin?: string;
    threshold?: number | number[];
    once?: boolean;
  },
) {
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    let didUnobserve = false;
    const observer = new window.IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          callback();
          if (options?.once !== false) {
            observer.unobserve(node);
            didUnobserve = true;
          }
        }
      },
      {
        root: options?.root || null,
        rootMargin: options?.rootMargin || "0px",
        threshold: options?.threshold || 0.1,
      },
    );
    observer.observe(node);
    return () => {
      if (!didUnobserve) observer.unobserve(node);
    };
  }, [ref, callback, options]);
}
